import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'organization-health-check',
    description:
      'Visualize results of an organizational health check related to strategic planning.',
    icon: 'summmit',
    name: 'Organization Health Check',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
